import React from "react"
import {Box, Button} from "@mui/material"

import {SMSMessageRow} from "./SMSMessageRow"
import type {ReplyAction} from "./SMSMessageRow"

import type {ConversationMessage} from "@indebted/api"

function SMSThread({
	messages,
	replyAnchorProviderMessageId,
	replyTargetProviderMessageId,
	hasMore,
	loadingMore,
	onShowEarlier,
	replyActionFor,
}: {
	messages: ConversationMessage[]
	replyAnchorProviderMessageId: string
	replyTargetProviderMessageId: string
	hasMore: boolean
	loadingMore: boolean
	onShowEarlier: () => void
	replyActionFor: (message: ConversationMessage) => ReplyAction | undefined
}) {
	const targetIsEarlier =
		replyTargetProviderMessageId !== "" && replyTargetProviderMessageId !== replyAnchorProviderMessageId

	return (
		<Box component="ul" display="flex" flexDirection="column" gap={1.5} m={0} p={0}>
			{messages.map((message) => {
				const isInbound = message.direction === "inbound"
				return (
					<SMSMessageRow
						key={`${message.direction}:${message.providerMessageId}:${message.occurredAt}`}
						message={message}
						isAnchor={isInbound && message.providerMessageId === replyAnchorProviderMessageId}
						isReplyTarget={isInbound && message.providerMessageId === replyTargetProviderMessageId}
						targetIsEarlier={targetIsEarlier}
						replyAction={replyActionFor(message)}
					/>
				)
			})}
			{hasMore && (
				<Button
					variant="text"
					size="small"
					onClick={onShowEarlier}
					disabled={loadingMore}
					sx={{alignSelf: "flex-start"}}
				>
					{loadingMore ? "Loading…" : "Show earlier"}
				</Button>
			)}
		</Box>
	)
}

export {SMSThread}
